function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "ico-export_module_svg__a",
  d: "M0 0h22v22H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "ico-export_module_svg__b"
}, React.createElement("use", {
  xlinkHref: "#ico-export_module_svg__a"
})), React.createElement("path", {
  d: "M21.586 14l-3.293-3.293a1 1 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L21.586 16H12a1 1 0 0 1 0-2h9.586zM12 23a1 1 0 0 1 0 2H8a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4a1 1 0 0 1 0 2H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4z",
  mask: "url(#ico-export_module_svg__b)",
  transform: "matrix(0 -.8 .8 0 0 22.8)"
}));

var SvgIcoExportModule = function SvgIcoExportModule(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
};

export default SvgIcoExportModule;